import Utils from "../util/Utils";

const JOB_FORM = (booking, dsrDetails) => {
    const SegmentName = booking.contract.shipmentType.substr(0, 3) + ' ' + booking.shipmentMovement
   return {
    Master: {
        OBL: {
            ID: booking._id,
            LocationCode: '',
            SegmentName: SegmentName,
            ModeOfTransport: booking.contract.shipmentType.substr(0, 3) === "AIR" ? "AIR" : "SEA",
            CreatePersonName: Utils.extractPersonName(booking.tsCreatedBy),
            CreatePersonEmail: booking.tsCreatedBy,
            CreateDate: Utils.getYearDayMonthFromUnix(booking.tsCreatedOn),
            OceanBLNum: booking.carrierMBL === "Yes" ? booking.mbl_number || "" : "",
            OceanBLDate: "", 
            AgentCode: "",
            AgentName: "",
            AgentAddress: "",
            PortOfReceipt: dsrDetails.por || "",
            PortOfLoading: dsrDetails.pol || "",
            PortOfDischarge:  dsrDetails.pod || "",
            FinalDestination:  dsrDetails.fpod || "",
            VesselName: booking.schedule.vesselName || "",
            VoyageNo: booking.schedule.voyageNo || "",
            Carrier: booking.contract.carrier || "",
            Etd: Utils.convertToYYYYMMDD(dsrDetails.etd_at_pod) || "",
            Eta: Utils.convertToYYYYMMDD(dsrDetails.eta_at_pod) || "",
            Atd: "",
            Ata: "",
            MasterPPCC: "",
            Service: "",
            TotalNoOfPack:'',
            TotalWeight: "",
            TotalVolume:"",
            MasterContainerDetails: booking.contract.containerList.map(container => ({
                ContainerCode: container.containerType || "",
                ContainerNo: "",
                SealNum: "",
                Hazardous: booking.contract.hazardous || "No",
                Class: "",
                CFSName: "",
                StuffingDate: "",
                DeStuffingDate: "",
            })),
        },
    },
    HBL: [
        {
            OurReferenceNo: booking._id,
            Service: "",
            Trade: "",
            HBLNo: "",
            ManifestHBLNo: "",
            PortOfReceipt: "",
            FinalDestination: dsrDetails.fpod || "",
            TosName: "",
            Freight: "",
            Routed: "",
            RoutedByName: "",
            RoutedByEmail: "",
            CommodityDesc: "",
            MarksNo: "",
            PackCode: "",
            PackDesc: "",
            NoOfPack: "",
            Volume: "",
            GrossWeight: "",
            DirectBL: "",
            ColoaderName: "",
            PickupPlace: "",
            CFSDeliveryPlace: "",
            DoorDeliveryPlace: "",
            Parties: [
                {
                    PartyType: "",
                    PartyCode: "",
                    PartyName: "",
                    Address: ""
                }
            ],
            HBLContainerDetails: [
                {
                    ContainerNo: "",
                    ExternalNoOfPack: "",
                    InternalNoOfPack: "",
                    Volume: "",
                    GrossWeight: ""
                }
            ],
            CommodityDetails: [
                {
                    ItemNo: "",
                    ItemDesc: "",
                    PackCode: "",
                    PackDesc: "",
                    NoOfPack: "",
                    GrossWeight: "",
                    Volume: "",
                    ImoNo: "",
                    UnNo: ""
                },
            ],
            // Events: [
            //     {
            //         Code: "",
            //         Description: "",
            //         Value: ""
            //     },
            // ],
            // References: [
            //     {
            //         Code: "",
            //         Description: "",
            //         Value: ""
            //     },
            // ]
        },
    ]
};

}

const BOOKING_FORM = (booking, dsrDetails) => {
    const SegmentName = booking.contract.shipmentType.substr(0, 3) + ' ' + booking.shipmentMovement;
    return {
        BOOKING_FORM: {
            Envelope: {
                SenderId: "",
                RecipientId: "",
                MessageType: "",
                MessageVersion: "",
                EnvelopeID: "",
                TransmissionDate: "",
                TransmissionTime: ""
            },
            BookingDetails: {
                RequestType: "",
                LocationCode: "",
                OurReferenceNo: "",
                BookingPersonName: "",
                BookingPersonEmail: "",
                BookingDate: "",
                ModeOfTransport: "",
                Service: "",
                SegmentName: "",
                PortOfReceipt: dsrDetails.por,
                PortOfLoading: dsrDetails.pol,
                PortOfDischarge: dsrDetails.pod,
                FinalDestination: dsrDetails.fpod,
                VesselName: "",
                VoyageNo: "",
                Carrier: "",
                TosName: "",
                Freight: "",
                Routed: "",
                RoutedByName: "",
                RoutedByEmail: "",
                CommodityDesc: "",
                MarksNo: "",
                PackCode: "",
                PackDesc: "",
                NoOfPack: "",
                Volume: "",
                GrossWeight: "",
                Etd: "",
                Eta: "",
                CargoReceivedDate: "",
                ShipperReferenceNo: "",
                ConsigneeReferenceNo: "",
                OBL: "",
                OBLFreight: "",
                DirectBL: "",
                ColoaderName: "",
                PickupPlace: "",
                CFSDeliveryPlace: "",
                DoorDeliveryPlace: "",
                ContainerDetails: [
                    {
                        ContainerCode: "",
                        ContainerNo: "",
                        StuffingType: ""
                    }
                ],
                CommodityDetails: [
                    {
                        ItemNo: "",
                        ItemDesc: "",
                        PackCode: "",
                        PackDesc: "",
                        NoOfPack: "",
                        GrossWeight: "",
                        Volume: "",
                        ImoNo: "",
                        UnNo: ""
                    }
                ],
                Parties: [
                    {
                        PartyType: "",
                        PartyCode: "",
                        PartyName: "",
                        Address: ""
                    }
                ]
            }
        }
    };
};



export { JOB_FORM, BOOKING_FORM }

// BOOKING_FORM: {
//     Envelope: {
//         SenderId: "VIR001",
//         RecipientId: "NEWAGE001",
//         MessageType: "BookingRequest",
//         MessageVersion: "1",
//         EnvelopeID: "20250210000130",
//         TransmissionDate: "2025-02-05",
//         TransmissionTime: "09:54:42"
//     },
//     BookingDetails: {
//         RequestType: "NEW",
//         LocationCode: "80111",
//         OurReferenceNo: "BE911414116625",
//         BookingPersonName: "GOWTHAM KONDEPUDI",
//         BookingPersonEmail: "gowtham.kondepudi@agraga.com",
//         BookingDate: "2025-02-05",
//         ModeOfTransport: "SEA",
//         Service: "FCL",
//         SegmentName: "FCL EXPORT",
//         PortOfReceipt: "INBOM",
//         PortOfLoading: "INBOM",
//         PortOfDischarge: "AEDXB",
//         FinalDestination: "AEDXB",
//         VesselName: "GREEN WICH BRIDGE",
//         VoyageNo: "0004E",
//         Carrier: "ASIA PACIFIC CONTAINER LINE",
//         TosName: "COST, INSURANCE AND FREIGHT",
//         Freight: "PREPAID",
//         Routed: "Self",
//         RoutedByName: "GOWTHAM KONDEPUDI",
//         RoutedByEmail: "gowtham.kondepudi@agraga.com",
//         CommodityDesc: "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//         MarksNo: "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//         PackCode: "DRM",
//         PackDesc: "DRUM(S)",
//         NoOfPack: "12",
//         Volume: "12.820",
//         GrossWeight: "362.33",
//         Etd: "2025-02-05",
//         Eta: "2025-02-09",
//         CargoReceivedDate: "2025-02-05T23:00:45",
//         ShipperReferenceNo: "2425-A301",
//         ConsigneeReferenceNo: "",
//         OBL: "27545376905",
//         OBLFreight: "PREPAID",
//         DirectBL: "Yes",
//         ColoaderName: "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//         PickupPlace: "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//         CFSDeliveryPlace: "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//         DoorDeliveryPlace: "GULSHAN BRANCH, DHAKA-BANGLADESH",
//         ContainerDetails: [
//             {
//                 ContainerCode: "22G0",
//                 ContainerNo: "DELI1234569",
//                 StuffingType: "CFS"
//             },
//             {
//                 ContainerCode: "22G0",
//                 ContainerNo: "BELI1234569",
//                 StuffingType: "CFS"
//             }
//         ],
//         CommodityDetails: [
//             {
//                 ItemNo: "1",
//                 ItemDesc: "NON HAZ",
//                 PackCode: "PKG",
//                 PackDesc: "PACKAGE(S)",
//                 NoOfPack: "5",
//                 GrossWeight: "725",
//                 Volume: "0.851",
//                 ImoNo: "3464",
//                 UnNo: "45566"
//             },
//             {
//                 ItemNo: "2",
//                 ItemDesc: "NON HAZ",
//                 PackCode: "PKG",
//                 PackDesc: "PACKAGE(S)",
//                 NoOfPack: "7",
//                 GrossWeight: "765",
//                 Volume: "0.654",
//                 ImoNo: "4567",
//                 UnNo: "5643"
//             }
//         ],
//         Parties: [
//             {
//                 PartyType: "SH",
//                 PartyCode: "C000090",
//                 PartyName: "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                 Address: "PLOT NO 12, WEST STREET, ANDHERI WEST"
//             },
//             {
//                 PartyType: "CN",
//                 PartyCode: "C000090",
//                 PartyName: "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                 Address: "PLOT NO 12, WEST STREET, ANDHERI WEST"
//             },
//             {
//                 PartyType: "BI",
//                 PartyCode: "C000090",
//                 PartyName: "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                 Address: "PLOT NO 12, WEST STREET, ANDHERI WEST"
//             },
//             {
//                 PartyType: "FW",
//                 PartyCode: "C000090",
//                 PartyName: "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                 Address: "PLOT NO 12, WEST STREET, ANDHERI WEST"
//             },
//             {
//                 PartyType: "NI",
//                 PartyCode: "C000090",
//                 PartyName: "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                 Address: "PLOT NO 12, WEST STREET, ANDHERI WEST"
//             },
//             {
//                 PartyType: "AG",
//                 PartyCode: "OD90007",
//                 PartyName: "DIVYA VENDOR NON IND",
//                 Address: "D204, RADIANCE MANDARIN,"
//             }
//         ]
//     }
// }
// const erpData = {
//     "LCL Export Booking": { message: "LCL Export Booking Data" },
//     "FCL Export Job": {
//         "Master": {
//             "OBL": {
//                 "ID": 17,
//                 "LocationCode": "80111",
//                 "SegmentName": "FCL EXPORT",
//                 "ModeOfTransport": "SEA",
//                 "CreatePersonName": "THIRUPPATHI NAADIMUTHU",
//                 "CreatePersonEmail": "msk@newage-global.com",
//                 "CreateDate": "2025-01-31",
//                 "OceanBLNum": "MBL7897878",
//                 "OceanBLDate": "2025-01-31",
//                 "AgentCode": "OD90007",
//                 "AgentName": "DIVYA VENDOR NON IND",
//                 "AgentAddress": "D204, RADIANCE MANDARIN,",
//                 "PortOfReceipt": "INBOM",
//                 "PortOfLoading": "INBOM",
//                 "PortOfDischarge": "AEDXB",
//                 "FinalDestination": "AEDXB",
//                 "VesselName": "GREEN WICH BRIDGE",
//                 "VoyageNo": "0004E",
//                 "Carrier": "ASIA PACIFIC CONTAINER LINE",
//                 "Etd": "2024-07-16",
//                 "Eta": "2024-07-18",
//                 "Atd": "2024-07-16",
//                 "Ata": "2024-07-18",
//                 "MasterPPCC": "COLLECT",
//                 "Service": "FCL/FCL",
//                 "TotalNoOfPack": "5",
//                 "TotalWeight": "362.33",
//                 "TotalVolume": "12.820",
//                 "MasterContainerDetails": [
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "DELI1234567",
//                         "SealNum": "CS987687",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-20"
//                     },
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "GELI1234567",
//                         "SealNum": "AS87678",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-21"
//                     }
//                 ]
//             },
//             "HBL": [
//                 {
//                     "OurReferenceNo": "LE917814116625",
//                     "Service": "FCL/FCL",
//                     "Trade": "Export",
//                     "HBLNo": "HBL678989898",
//                     "ManifestHBLNo": "678996876",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "DELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 },
//                 {
//                     "OurReferenceNo": "LE917914116635",
//                     "Service": "FCL/FCL",
//                     "Trade": "Export",
//                     "HBLNo": "HBL668768778789",
//                     "ManifestHBLNo": "6746454893689",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "GELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 }
//             ]
//         }
//     },
//     "LCL Import Job": {
//         "Master": {
//             "OBL": {
//                 "ID": 20,
//                 "LocationCode": "80111",
//                 "SegmentName": "LCL IMPORT (SEA)",
//                 "ModeOfTransport": "SEA",
//                 "CreatePersonName": "THIRUPPATHI NAADIMUTHU",
//                 "CreatePersonEmail": "msk@newage-global.com",
//                 "CreateDate": "2025-01-31",
//                 "OceanBLNum": "MBL7897878",
//                 "OceanBLDate": "2025-01-31",
//                 "AgentCode": "OD90007",
//                 "AgentName": "DIVYA VENDOR NON IND",
//                 "AgentAddress": "D204, RADIANCE MANDARIN,",
//                 "PortOfReceipt": "INBOM",
//                 "PortOfLoading": "INBOM",
//                 "PortOfDischarge": "AEDXB",
//                 "FinalDestination": "AEDXB",
//                 "VesselName": "GREEN WICH BRIDGE",
//                 "VoyageNo": "0004E",
//                 "Carrier": "ASIA PACIFIC CONTAINER LINE",
//                 "Etd": "2024-07-16",
//                 "Eta": "2024-07-18",
//                 "Atd": "2024-07-16",
//                 "Ata": "2024-07-18",
//                 "MasterPPCC": "COLLECT",
//                 "Service": "LCL/LCL",
//                 "TotalNoOfPack": "5",
//                 "TotalWeight": "362.33",
//                 "TotalVolume": "12.820",
//                 "MasterContainerDetails": [
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "HELI1234567",
//                         "SealNum": "CS987687",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-20"
//                     },
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "JELI1234567",
//                         "SealNum": "AS87678",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-21"
//                     }
//                 ]
//             },
//             "HBL": [
//                 {
//                     "OurReferenceNo": "OE917814116625",
//                     "Service": "LCL/LCL",
//                     "Trade": "Import",
//                     "HBLNo": "HBL678989898",
//                     "ManifestHBLNo": "678996876",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "HELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 },
//                 {
//                     "OurReferenceNo": "OE917914116635",
//                     "Service": "LCL/LCL",
//                     "Trade": "Import",
//                     "HBLNo": "HBL668768778789",
//                     "ManifestHBLNo": "6746454893689",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "JELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 }
//             ]
//         }
//     },
//     "FCL Export Booking": { message: "FCL Export Booking Data" },
//     "LCL Export Job": {
//         "Master": {
//             "OBL": {
//                 "ID": 18,
//                 "LocationCode": "80111",
//                 "SegmentName": "LCL EXPORT (SEA)",
//                 "ModeOfTransport": "SEA",
//                 "CreatePersonName": "THIRUPPATHI NAADIMUTHU",
//                 "CreatePersonEmail": "msk@newage-global.com",
//                 "CreateDate": "2025-01-31",
//                 "OceanBLNum": "MBL7897878",
//                 "OceanBLDate": "2025-01-31",
//                 "AgentCode": "OD90007",
//                 "AgentName": "DIVYA VENDOR NON IND",
//                 "AgentAddress": "D204, RADIANCE MANDARIN,",
//                 "PortOfReceipt": "INBOM",
//                 "PortOfLoading": "INBOM",
//                 "PortOfDischarge": "AEDXB",
//                 "FinalDestination": "AEDXB",
//                 "VesselName": "GREEN WICH BRIDGE",
//                 "VoyageNo": "0004E",
//                 "Carrier": "ASIA PACIFIC CONTAINER LINE",
//                 "Etd": "2024-07-16",
//                 "Eta": "2024-07-18",
//                 "Atd": "2024-07-16",
//                 "Ata": "2024-07-18",
//                 "MasterPPCC": "COLLECT",
//                 "Service": "LCL/LCL",
//                 "TotalNoOfPack": "5",
//                 "TotalWeight": "362.33",
//                 "TotalVolume": "12.820",
//                 "MasterContainerDetails": [
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "DELI1234567",
//                         "SealNum": "CS987687",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-20"
//                     },
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "GELI1234567",
//                         "SealNum": "AS87678",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-21"
//                     }
//                 ]
//             },
//             "HBL": [
//                 {
//                     "OurReferenceNo": "ME917814116625",
//                     "Service": "LCL/LCL",
//                     "Trade": "Export",
//                     "HBLNo": "HBL678989898",
//                     "ManifestHBLNo": "678996876",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "DELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 },
//                 {
//                     "OurReferenceNo": "ME917914116635",
//                     "Service": "LCL/LCL",
//                     "Trade": "Export",
//                     "HBLNo": "HBL668768778789",
//                     "ManifestHBLNo": "6746454893689",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "GELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 }
//             ]
//         }
//     },
//     "FCL Import Job": {
//         "Master": {
//             "OBL": {
//                 "ID": 19,
//                 "LocationCode": "80111",
//                 "SegmentName": "FCL IMPORT (SEA)",
//                 "ModeOfTransport": "SEA",
//                 "CreatePersonName": "THIRUPPATHI NAADIMUTHU",
//                 "CreatePersonEmail": "msk@newage-global.com",
//                 "CreateDate": "2025-01-31",
//                 "OceanBLNum": "MBL7897878",
//                 "OceanBLDate": "2025-01-31",
//                 "AgentCode": "OD90007",
//                 "AgentName": "DIVYA VENDOR NON IND",
//                 "AgentAddress": "D204, RADIANCE MANDARIN,",
//                 "PortOfReceipt": "INBOM",
//                 "PortOfLoading": "INBOM",
//                 "PortOfDischarge": "AEDXB",
//                 "FinalDestination": "AEDXB",
//                 "VesselName": "GREEN WICH BRIDGE",
//                 "VoyageNo": "0004E",
//                 "Carrier": "ASIA PACIFIC CONTAINER LINE",
//                 "Etd": "2024-07-16",
//                 "Eta": "2024-07-18",
//                 "Atd": "2024-07-16",
//                 "Ata": "2024-07-18",
//                 "MasterPPCC": "COLLECT",
//                 "Service": "FCL/FCL",
//                 "TotalNoOfPack": "5",
//                 "TotalWeight": "362.33",
//                 "TotalVolume": "12.820",
//                 "MasterContainerDetails": [
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "DELI1234567",
//                         "SealNum": "CS987687",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-20"
//                     },
//                     {
//                         "ContainerCode": "22G0",
//                         "ContainerNo": "GELI1234567",
//                         "SealNum": "AS87678",
//                         "Hazardous": "",
//                         "Class": "",
//                         "CFSName": "CFSMUMBAI",
//                         "StuffingDate": "2024-07-18",
//                         "DeStuffingDate": "2024-07-21"
//                     }
//                 ]
//             },
//             "HBL": [
//                 {
//                     "OurReferenceNo": "NE917814116625",
//                     "Service": "FCL/FCL",
//                     "Trade": "Import",
//                     "HBLNo": "HBL678989898",
//                     "ManifestHBLNo": "678996876",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "DELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 },
//                 {
//                     "OurReferenceNo": "NE917914116635",
//                     "Service": "FCL/FCL",
//                     "Trade": "Import",
//                     "HBLNo": "HBL668768778789",
//                     "ManifestHBLNo": "6746454893689",
//                     "PortOfReceipt": "INBOM",
//                     "FinalDestination": "AEDXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [
//                         {
//                             "ContainerNo": "GELI1234567",
//                             "ExternalNoOfPack": "12",
//                             "InternalNoOfPack": "1",
//                             "Volume": "12.820",
//                             "GrossWeight": "362.33"
//                         }
//                     ],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 }
//             ]
//         }
//     },
//     "AIR Export Booking": { message: "AIR Export Booking Data" },
//     "AIR Export Job": {
//         "Master": {
//             "OBL": {
//                 "ID": 16,
//                 "LocationCode": "80111",
//                 "SegmentName": "AIR EXPORT",
//                 "ModeOfTransport": "AIR",
//                 "CreatePersonName": "THIRUPPATHI NAADIMUTHU",
//                 "CreatePersonEmail": "msk@newage-global.com",
//                 "CreateDate": "2025-01-31",
//                 "OceanBLNum": "MAWB7897878",
//                 "OceanBLDate": "2025-01-31",
//                 "AgentCode": "OD90007",
//                 "AgentName": "DIVYA VENDOR NON IND",
//                 "AgentAddress": "D204, RADIANCE MANDARIN,",
//                 "PortOfReceipt": "BOM",
//                 "PortOfLoading": "BOM",
//                 "PortOfDischarge": "DXB",
//                 "FinalDestination": "DXB",
//                 "VesselName": "GREEN WICH BRIDGE",
//                 "VoyageNo": "0004E",
//                 "Carrier": "ASIA PACIFIC CONTAINER LINE",
//                 "Etd": "2024-07-16",
//                 "Eta": "2024-07-18",
//                 "Atd": "2024-07-16",
//                 "Ata": "2024-07-18",
//                 "MasterPPCC": "COLLECT",
//                 "Service": "FCL/FCL",
//                 "TotalNoOfPack": "5",
//                 "TotalWeight": "362.33",
//                 "TotalVolume": "12.820",
//                 "MasterContainerDetails": []
//             },
//             "HBL": [
//                 {
//                     "OurReferenceNo": "KE917814116625",
//                     "Service": "FCL/FCL",
//                     "Trade": "Export",
//                     "HBLNo": "HAWB678989898",
//                     "ManifestHBLNo": "678996876",
//                     "PortOfReceipt": "BOM",
//                     "FinalDestination": "DXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 },
//                 {
//                     "OurReferenceNo": "KE917914116635",
//                     "Service": "FCL/FCL",
//                     "Trade": "Export",
//                     "HBLNo": "HAWB668768778789",
//                     "ManifestHBLNo": "6746454893689",
//                     "PortOfReceipt": "BOM",
//                     "FinalDestination": "DXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 }
//             ]
//         }
//     },
//     "AIR Import Job": {
//         "Master": {
//             "OBL": {
//                 "ID": 15,
//                 "LocationCode": "80111",
//                 "SegmentName": "AIR IMPORT",
//                 "ModeOfTransport": "AIR",
//                 "CreatePersonName": "THIRUPPATHI NAADIMUTHU",
//                 "CreatePersonEmail": "msk@newage-global.com",
//                 "CreateDate": "2025-01-31",
//                 "OceanBLNum": "MAWB7897878",
//                 "OceanBLDate": "2025-01-31",
//                 "AgentCode": "OD90007",
//                 "AgentName": "DIVYA VENDOR NON IND",
//                 "AgentAddress": "D204, RADIANCE MANDARIN,",
//                 "PortOfReceipt": "BOM",
//                 "PortOfLoading": "BOM",
//                 "PortOfDischarge": "DXB",
//                 "FinalDestination": "DXB",
//                 "VesselName": "GREEN WICH BRIDGE",
//                 "VoyageNo": "0004E",
//                 "Carrier": "ASIA PACIFIC CONTAINER LINE",
//                 "Etd": "2024-07-16",
//                 "Eta": "2024-07-18",
//                 "Atd": "2024-07-16",
//                 "Ata": "2024-07-18",
//                 "MasterPPCC": "COLLECT",
//                 "Service": "FCL/FCL",
//                 "TotalNoOfPack": "5",
//                 "TotalWeight": "362.33",
//                 "TotalVolume": "12.820",
//                 "MasterContainerDetails": []
//             },
//             "HBL": [
//                 {
//                     "OurReferenceNo": "JE917814116625",
//                     "Service": "FCL/FCL",
//                     "Trade": "Import",
//                     "HBLNo": "HAWB678989898",
//                     "ManifestHBLNo": "678996876",
//                     "PortOfReceipt": "BOM",
//                     "FinalDestination": "DXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 },
//                 {
//                     "OurReferenceNo": "JE917914116635",
//                     "Service": "FCL/FCL",
//                     "Trade": "Import",
//                     "HBLNo": "HAWB668768778789",
//                     "ManifestHBLNo": "6746454893689",
//                     "PortOfReceipt": "BOM",
//                     "FinalDestination": "DXB",
//                     "TosName": "COST, INSURANCE AND FREIGHT",
//                     "Freight": "PREPAID",
//                     "Routed": "Self",
//                     "RoutedByName": "GOWTHAM KONDEPUDI",
//                     "RoutedByEmail": "gowtham.kondepudi@agraga.com",
//                     "CommodityDesc": "CEFUROXIME AXETIL USP GRADE:AMORPHOUS",
//                     "MarksNo": "SHIPPING MARKS: TGC-262/24 RANGS PHARMA DHAKA",
//                     "PackCode": "DRM",
//                     "PackDesc": "DRUM(S)",
//                     "NoOfPack": "12",
//                     "Volume": "12.820",
//                     "GrossWeight": "362.33",
//                     "DirectBL": "Yes",
//                     "ColoaderName": "AAYURVEDA BIOCHEM INDIA PVT. LTD.",
//                     "PickupPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "CFSDeliveryPlace": "H.NO 8-3-667/18 SECOND FLOOR, S.K.D.NAGAR,YELLAREDDYGUDA, HYDERABAD, TELENGANA, 500073, INDIA.",
//                     "DoorDeliveryPlace": "GULSHAN BRANCH, DHAKA-BANGLADESH",
//                     "Parties": [
//                         {
//                             "PartyType": "SH",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "CN",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "BI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "FW",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "NI",
//                             "PartyCode": "C000090",
//                             "PartyName": "EXPRESS GLOBE FIRST BATCH CUSTOMER LTD",
//                             "Address": "PLOT NO 12, WEST STREET, ANDHERI WEST"
//                         },
//                         {
//                             "PartyType": "AG",
//                             "PartyCode": "OD90007",
//                             "PartyName": "DIVYA VENDOR NON IND",
//                             "Address": "D204, RADIANCE MANDARIN,"
//                         }
//                     ],
//                     "HBLContainerDetails": [],
//                     "CommodityDetails": [
//                         {
//                             "ItemNo": "1",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "5",
//                             "GrossWeight": "725",
//                             "Volume": "0.851",
//                             "ImoNo": "IM87678",
//                             "UnNo": "UN67567"
//                         },
//                         {
//                             "ItemNo": "2",
//                             "ItemDesc": "NON HAZ",
//                             "PackCode": "PKG",
//                             "PackDesc": "PACKAGE(S)",
//                             "NoOfPack": "7",
//                             "GrossWeight": "765",
//                             "Volume": "0.654",
//                             "ImoNo": "IMO8678",
//                             "UnNo": "UN978968"
//                         }
//                     ],
//                     "Events": [
//                         {
//                             "Code": "APU",
//                             "Description": "ACTUAL PICK UP",
//                             "Value": "2024-11-28T13:56:16"
//                         },
//                         {
//                             "Code": "BDS",
//                             "Description": "BL DRAFT SHARED",
//                             "Value": "2024-12-05T13:56:16"
//                         }
//                     ],
//                     "References": [
//                         {
//                             "Code": "CRI",
//                             "Description": "CARRIER CODE",
//                             "Value": "2425-A300"
//                         },
//                         {
//                             "Code": "HSC",
//                             "Description": "COMMODITY",
//                             "Value": "ASD"
//                         }
//                     ]
//                 }
//             ]
//         }
//     }
// }

// EXPORT booking API & JOB API
// IMPORT JOB API

{/* <label>
        Select ERP:
        <select
          value={snapshot.selectedERP || ""}
          onChange={(e) => (taskStore.selectedERP = e.target.value)}
        >
          <option value="">Select ERP</option>
          {Object.keys(erpData).map((erp) => (
            <option key={erp} value={erp}>
              {erp}
            </option>
          ))}
        </select>
      </label> */}